export const getCompanyRepProgressStepsLabels = (hasPersonSelection: boolean): string[] => {
  const stepLabels = []
  if (hasPersonSelection) {
    stepLabels.push('company-reps.person-selection-step.label')
  }
  return [
    ...stepLabels,
    'company-reps.person-identification-step.label',
    'company-reps.person-address-step.label',
  ]
}
